// extracted by mini-css-extract-plugin
module.exports = {"storeContainer":"StoreComponent_storeContainer__Vetpr","storeTitle":"StoreComponent_storeTitle__1SPAB","storeData":"StoreComponent_storeData__10tYP"};